/* eslint no-eval: 0 */

import React, { useEffect, useState } from 'react';
//style={{ color: 'purple' }}
import { Datagrid, List } from 'react-admin';
import FiltreRecherche from '../filtres/FiltreRecherche';
//import ExportAgExp from './ExportAgExp';
import PostPagination from '../paginations/pagination';
import { SearchResultField } from '../references.js';
import rowStyle from '../styles/rowStyle';

 const  ListRecherche=(props)=>{

    const [fullname, setFullname] = useState('');
   // const [reste_a_payer, setReste_a_payer] = useState();
   // const [roles, setRole] = useState();

    useEffect(() => {
        setFullname(localStorage.getItem('fullname'));
        //setRole(localStorage.getItem('roles'));
    }, []);

    /*
    const selectableAerien=(livre_user_id,camp_type,status)=>{
       return  (livre_user_id!=null && livre_user_id==0 && !has_role(roles,'ROLE_MANAGER')) &&
       (camp_type=='AERIEN' && !has_role(roles,'ROLE_AG_EXP_AERIEN_FR')) &&
       (status!='ASK') || (has_role(roles,'ROLE_MANAGER') && status=='ASK')
    }
    */
 return(
        <List {...props} 
                //bulkActionButtons={<PostBulkActionButtons reste_a_payer={reste_a_payer} roles={roles} />}
               // actions={<ListActions/>}
                filters={<FiltreRecherche />} 
                pagination={<PostPagination />}
                sort={{ field: 'id', order: 'ASC' }}
                title={'Recherche - '+fullname}
                empty={false}
                bulkActionButtons={false}
            >
                
            <Datagrid rowStyle={rowStyle} isRowSelectable={()=>false} >
              
                <SearchResultField  source="message" label="Messages"  component="pre"/>
                
            </Datagrid>
        </List>
       ) ;
    };



export default ListRecherche;

/*
const get_url=(reste_a_payer,selectedIds,code,roles)=>{
    var url=null;
    if(has_role(roles,'ROLE_MANAGER') && reste_a_payer>0){
        url='/etiq/livreParManager?ids=' + selectedIds;
    }else{
        url= !has_role(roles,'ROLE_MANAGER') && reste_a_payer > 0 ? 
        '/etiq/auhthoLivraisonAvecReste?ids=' + selectedIds+'&code='+code :
        '/etiq/updateLivraisonEtiq?ids=' + selectedIds+'&code='+code;
    }

    return process.env.REACT_APP_URL +url;
}

const PostBulkActionButtons = props => (
    <Fragment>
        
        <ResetViewsButton label={!has_role(props.roles,'ROLE_MANAGER') && props.reste_a_payer > 0 ? 'Authorisation': 'Livré'}
            title={!has_role(props.roles,'ROLE_MANAGER') && props.reste_a_payer > 0 ? "Demende d'authorisation de livraison":'Livraison des colis séléctionnés'}
            content={!has_role(props.roles,'ROLE_MANAGER') && props.reste_a_payer > 0 ? "Voulez vous demander une authorisation de livraison des colis sélectionnés":'Voulez vous livrer les colis séléctionnés ?'} {...props} 
            url={get_url(props.reste_a_payer,props.selectedIds,props.filterValues.code,props.roles)}
            startIcon={<LocalShippingIcon/>}
        />
    </Fragment>
);


const ListActions = (props) => {
    const {
        className,
        exporter,
        filters,
        maxResults,
        ...rest
    } = props;
    const {
        currentSort,
        resource,
        displayedFilters,
        filterValues,
        hasCreate,
        basePath,
        selectedIds,
        showFilter,
        total,
    } = useListContext();
    return (
        <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
            {filters && cloneElement(filters, {
                resource,
                showFilter,
                displayedFilters,
                filterValues,
                context: 'button',
            })}
        
            <CreateButton basePath={basePath} />
        </TopToolbar>
    );
};
*/





/*
const GuetsiAction = ({
    bulkActions,
    basePath,
    currentSort,
    displayedFilters,
    exporter,
    filters,
    filterValues,
    onUnselectItems,
    resource,
    selectedIds,
    showFilter,
    total,
    data,
    record,
    ...rest
}) => (
    <TopToolbar>
        {bulkActions && React.cloneElement(bulkActions, {
            basePath,
            filterValues,
            resource,
            selectedIds,
            onUnselectItems,
            record,
            data
        })}
        {filters && React.cloneElement(filters, {
            resource,
            showFilter,
            displayedFilters,
            filterValues,
            context: 'button',
        }) }
        
        <Button source="credit_status" label="Colis"  color="primary" onClick={()=>this.handleClick()}> <VerticalSplit /> </Button>  
        <CreateButton basePath={basePath} />

    </TopToolbar>
);



*/